"use client";
import { Image as CrystallizeImage } from "@crystallize/reactjs-components";
import { useAppContext } from "../../app-context/provider";
import { Footer as FooterType } from "~/use-cases/contracts/Footer";
import Logo from "~/assets/da-footer-logo.png";
import Image from "next/image";
import Link from "~/bridge/ui/Link";
import React from "react";
import LipscoreServiceModal from "../aplia/Lipscore/LipScoreServiceModal";
import { RichTextRenderer } from "~/ui/components/rich-text-renderer";

export const Footer: React.FC<{
  footer: FooterType;
}> = ({ footer }) => {
  const { state: appContextState, path } = useAppContext();

  return (
    <footer className="2xl w-full mx-auto">
      <div className="px-6 md:px-6 mx-auto xl:container full pt-12 pb-16 md:pb-0">
        <div>
          <Link to={path("/")} className="inline-block">
            <div className="max-h-[80px] h-[70px] max-w-[300px] min-w-[200px] img-container">
              <CrystallizeImage
                alt={footer.logo?.[0].altText}
                src={footer.logo?.[0].url}
                fallbackAlt="Logo"
                width={600}
              />
            </div>
          </Link>
          {footer.socialLinks && (
            <div className="social-links flex gap-2 items-center">
              {footer.socialLinks.map((socialLink, index) => (
                <a
                  key={socialLink.link + index}
                  href={socialLink.link}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <CrystallizeImage
                    {...socialLink.logo?.[0]}
                    sizes="100px"
                    fallbackAlt={socialLink.link}
                    width={23}
                    height={23}
                  />
                </a>
              ))}
            </div>
          )}
          {footer.dmp && (
            <div className="my-5">
              <div className="md:w-1/3">
                <RichTextRenderer json={footer.dmp.json} />
              </div>
            </div>
          )}
        </div>
        <div className="grid sm:grid-cols-3 grid-cols-1 gap-3">
          <div className="footer-links">
            <div className="footer-links__left">
              {footer.contact && (
                <RichTextRenderer json={footer.contact.json} />
              )}
              <div className="mt-4">
                {footer.aapningstider && (
                  <RichTextRenderer json={footer.aapningstider.json} />
                )}
              </div>
            </div>
          </div>
          <div className="footer-links">
            <h4>Snarveier</h4>
            <div className="footer-links__right">
              {footer.links && <RichTextRenderer json={footer.links.json} />}
            </div>
          </div>
          <div className="text-right flex md:items-center md:ml-auto flex-col">
            <div className="my-5">
              <a
                href="https://legemiddelverket.no/import-og-salg/apotekdrift/registreringsordning-for-netthandel-med-legemidler/godkjente-utsalgssteder"
                target="_blank"
                rel="noreferrer noopner"
              >
                <img
                  src="/dmp-logo.png"
                  width={200}
                  alt="Klikk her for å se om denne nettsiden driver lovlig"
                />
              </a>
            </div>

            <a
              href="https://www.apotek.no"
              target="_blank"
              rel="noreferrer noopner"
            >
              <img
                src="/apotekforeningen.png"
                width={200}
                alt="Klikk her for å gå til apotekforeningens nettsider"
              />
            </a>
          </div>
        </div>

        <div className="mx-auto flex items-center mt-20 pb-5 pt-3 justify-between">
          <div className="text-sm">
            Copyright © {new Date().getFullYear()} Roslandgruppen AS - Utviklet
            av{" "}
            <a
              href="https://aplia.no"
              className="underline"
              rel="noreferrer noopner"
            >
              Aplia
            </a>{" "}
            - Powered by{" "}
            <a
              href="https://crystallize.com"
              className="underline"
              rel="noreferrer noopner"
            >
              Crystallize
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};
